export const HOLDER_LOG_LIST_REQUEST = 'HOLDER_LOG_LIST_REQUEST';
